import React from "react";
import Portfolio from "../../componets/Portfolio";

export default function Section1() {
  return (
    <div className="w-full h-[45vh] xl:h-[80vh] Section1">
      <Portfolio
        bgImage={"assets/mean3-banner-image-home.jpg"}
        objectPosition={"object-[center_20%]"}
        customer={false}
        altText="Mean3 Banner Image"
      />
    </div>
  );
}
